<template>
  <div class="flex flex-col min-h-screen items-center">
    <div class="flex justify-between items-center w-full max-w-[1280px]">
      <div class="flex">
        <PopupUserMenu
          :user="user"
          :active-item="'entra'"
        />
        <LogoIcon />
      </div>
      <DropdownMenu />
    </div>
    <div class="flex flex-grow max-w-[1280px] mt-[60px] mx-auto w-full">
      <UserMenu
        :user="user"
        :active-item="'entra'"
      />
      <EntraSetup />
    </div>
  </div>
</template>

<script>
import { computed } from 'vue';
import { useAuthStore } from '@/stores/auth';
import LogoIcon from '@/components/LogoIcon.vue';
import DropdownMenu from "@/components/DropdownMenu.vue";
import UserMenu from "@/components/UserMenu.vue";
import EntraSetup from "@/components/EntraSetup.vue";
import PopupUserMenu from "@/components/PopupUserMenu.vue";

export default {
    name: 'EntraIdConfigPage',
    components: {
        PopupUserMenu,
        LogoIcon,
        DropdownMenu,
        UserMenu,
        EntraSetup,
    },
    setup() {
        const authStore = useAuthStore();
        const user = computed(() => authStore.current_user);

        return {
            user,
        };
    },
}
</script>